// Wholesale Coffee Cup Product - Compostable Single Wall
console.log('🥤 Loading Wholesale Coffee Cup (Compostable) JavaScript...');

// Variant mapping (Single Wall) with real Shopify variant IDs
const variantMapping = {
  '4oz': {
    '10000': '50895817867546',
    '16000': '50895817900314',
    '32000': '50895817965850',
    '50000': '50895817933082',
    '64000': '50895817998618'
  },
  '6oz': {
    '10000': '50895818031386',
    '16000': '50895818064154',
    '32000': '50895818129690',
    '50000': '50895818096922',
    '64000': '50895818162458'
  },
  '8oz': {
    '10000': '50895818195226',
    '16000': '50895818227994',
    '32000': '50895818293530',
    '50000': '50895818260762',
    '64000': '50895818326298'
  },
  '12oz': {
    '10000': '50895818359066',
    '16000': '50895818391834',
    '32000': '50895818457370',
    '50000': '50895818424602',
    '64000': '50895818490138'
  },
  '16oz': {
    '10000': '50895818522906',
    '16000': '50895818555674',
    '32000': '50895818621210',
    '50000': '50895818588442',
    '64000': '50895818653978'
  },
  '22oz': {
    '10000': '50895818686746',
    '16000': '50895818719514',
    '32000': '50895818785050',
    '50000': '50895818752282',
    '64000': '50895818817818'
  },
  '24oz': {
    '10000': '50895818850586',
    '16000': '50895818883354',
    '32000': '50895818948890',
    '50000': '50895818916122',
    '64000': '50895818981658'
  }
};

// Variant mapping for Double Wall (Compostable) from separate product
// Only sizes 8oz, 12oz, 16oz are available for Double Wall in wholesale
const variantMappingDouble = {
  '8oz': {
    '10000': '51112531099930',
    '16000': '51112531132698',
    '32000': '51112531165466',
    '50000': '51112531198234',
    '64000': '51112531231002'
  },
  '12oz': {
    '10000': '51112531263770',
    '16000': '51112531296538',
    '32000': '51112531329306',
    '50000': '51112531362074',
    '64000': '51112531394842'
  },
  '16oz': {
    '10000': '51112531427610',
    '16000': '51112531460378',
    '32000': '51112531493146',
    '50000': '51112531525914',
    '64000': '51112531558682'
  }
};

// Plate fee variant IDs
const plateFeeVariantId = '50971398013210'; // Standard plate fee $175
const urgentPlateFeeVariantId = '50971398045978'; // Urgent plate fee $250

// Lid variant IDs (compostable coffee wholesale includes lids)
// White: tiered by quantity; Black: keep existing mapping (update if tiers provided later)
const lidVariantMapping = {
  'white': {
    '250': '50731404165402',
    '500': '50731404198170',
    '1000': '50731404230938',
    '2000': '50731404263706',
    '3000': '50731404296474',
    '4000': '50731404329242',
    '5000': '50731404362010',
    '10000': '50731404394778',
    '16000': '50731610341658',
    '32000': '50731610374426',
    '50000': '50896131817754',
    '64000': '50731610407194'
  },
  'black': '50882161836314'
};

// Color restrictions by quantity
const colourRules = {
  '10000': 1,   // 1 color only
  '16000': 2,   // 1-2 colors  
  '32000': 3,   // 1-3 colors
  '50000': 4,   // 1-4 colors
  '64000': 5    // 1-5 colors
};

// Rush fee variant ID ($1 product for calculated rush fees)
const rushFeeVariantId = '50675778126106';

class CompostableCoffeeCupWholesaleProduct {
    constructor() {
    console.log('CompostableCoffeeCupWholesaleProduct initialized');
    
    // State
    this.selectedSize = '8oz';
      this.selectedWall = 'Single'; // Single | Double
    this.selectedPrintType = 'Flexographic';
    this.selectedQuantity = 10000;
    this.selectedColours = 1;
    this.selectedLids = 'no';
    this.selectedTurnaround = 'standard';
    
    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;
    this.variantPriceCache = new Map();
    this._pricingRenderCounter = 0;
    
      // Constants
      this.singleWallUnitsPerCarton = 1000;
      this.doubleWallUnitsPerCarton = 500; // Double wall uses different cartons
      this.UNITS_PER_CARTON = this.singleWallUnitsPerCarton;
    this.STANDARD_PLATE_FEE = 175; // $175 standard plate fee
    this.URGENT_PLATE_FEE = 250;   // $250 urgent plate fee
    this.LID_PRICE_HIGH_QTY = 0.059; // align with recyclable wholesale
    this.LID_PRICE_LOW_QTY = 0.069;
    
    // Rush multipliers for different turnaround times (30 business days standard for coffee wholesale)
    this.RUSH_MULTIPLIERS = {
      'standard': 1.0,   // 30 business days - no surcharge
      '20days': 1.10,    // 20 business days - +10%
      '10days': 1.20,    // 10 business days - +20%
      '5days': 1.30      // 5 business days - +30%
    };
    
    // Color rules based on quantity
    this.colourRules = {
      10000: { min: 1, max: 1 },
      16000: { min: 1, max: 2 },
      32000: { min: 1, max: 3 },
      50000: { min: 1, max: 4 },
      64000: { min: 1, max: 5 }
    };
    
      // Variant mappings for wholesale quantities with actual IDs
      this.variantMappingSingle = variantMapping;
      this.variantMappingDouble = variantMappingDouble;
      this.variantMapping = this.variantMappingSingle;
      
    this.init().catch(error => console.error('Initialization error:', error));
    }

    async init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupWallSelector();
    this.setupColorSelector();
    this.setupLidsSelector();
    this.setupTurnaroundSelector();
    this.setupTooltips();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    // Sync wall availability against initial size
    if (typeof this.updateWallAvailability === 'function') {
      this.updateWallAvailability();
    }
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial size/print combination
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  setupWallSelector() {
    const wallButtons = document.querySelectorAll('.wall-btn');
    this.allowedDoubleSizes = new Set(['8oz', '12oz', '16oz']);
    const incompatiblePopup = document.getElementById('double-wall-incompatible-popup');
    const unavailableIndicator = document.querySelector('#double-wall-btn .unavailable-indicator');

    const refreshUnavailableIndicator = () => {
      const shouldShow = !this.allowedDoubleSizes.has(this.selectedSize);
      if (unavailableIndicator) unavailableIndicator.style.display = shouldShow ? '' : 'none';
      const doubleBtn = document.getElementById('double-wall-btn');
      if (doubleBtn) doubleBtn.classList.toggle('disabled', shouldShow);
      if (shouldShow && this.selectedWall === 'Double') {
        const singleBtn = document.querySelector('.wall-btn[data-wall="Single"]');
        if (singleBtn) singleBtn.click();
      }
    };
    refreshUnavailableIndicator();

    wallButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const chosen = btn.dataset.wall === 'Double' ? 'Double' : 'Single';

        if (chosen === 'Double' && !this.allowedDoubleSizes.has(this.selectedSize)) {
          if (incompatiblePopup) {
            incompatiblePopup.style.opacity = '1';
            incompatiblePopup.style.visibility = 'visible';
            setTimeout(() => {
              incompatiblePopup.style.opacity = '0';
              incompatiblePopup.style.visibility = 'hidden';
            }, 1800);
          }
          return;
        }

        wallButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedWall = chosen;
        if (this.selectedWall === 'Double') {
          this.variantMapping = this.variantMappingDouble;
          this.UNITS_PER_CARTON = this.doubleWallUnitsPerCarton;
        } else {
          this.variantMapping = this.variantMappingSingle;
          this.UNITS_PER_CARTON = this.singleWallUnitsPerCarton;
        }

        this.autoSelectMOQQuantity();
        refreshUnavailableIndicator();
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  updateWallAvailability() {
    const doubleBtn = document.getElementById('double-wall-btn');
    const unavailableIndicator = doubleBtn?.querySelector('.unavailable-indicator');
    const isAllowed = this.allowedDoubleSizes ? this.allowedDoubleSizes.has(this.selectedSize) : ['8oz','12oz','16oz'].includes(this.selectedSize);
    if (doubleBtn) doubleBtn.classList.toggle('disabled', !isAllowed);
    if (unavailableIndicator) unavailableIndicator.style.display = isAllowed ? 'none' : '';
    if (!isAllowed && this.selectedWall === 'Double') {
      const singleBtn = document.querySelector('.wall-btn[data-wall="Single"]');
      if (singleBtn) singleBtn.click();
    }
  }

  // Auto-select MOQ quantity based on size and print type
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    if (!variants) return;
    
    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ
    
    console.log(`Auto-selecting MOQ for ${pricingKey}: ${moqQuantity}`);
    
    // Update the selected quantity
    this.selectedQuantity = moqQuantity;
    
    // Update available colors based on quantity
    this.updateColorAvailability();
  }

  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
      if (typeof this.updateWallAvailability === 'function') {
        this.updateWallAvailability();
      }
        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when size changes
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('[PrintType Debug] Print type selected:', this.selectedPrintType);
        
        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when print type changes
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupColorSelector() {
    const colorButtons = document.querySelectorAll('.color-btn');
    colorButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Only allow selection if not disabled
        if (btn.classList.contains('disabled')) return;
        
        // Update selection
        colorButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedColours = parseInt(btn.dataset.colors);
        console.log('Colors selected:', this.selectedColours);
        
        this.updatePricingTable();
      });
    });
  }

  setupLidsSelector() {
    const lidsButtons = document.querySelectorAll('.lids-pill');
    lidsButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        lidsButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        // Track lids selection from pills
        const lidsValue = btn.dataset.lids || 'no';
        this.requireLids = lidsValue !== 'no';
        this.selectedLids = lidsValue;
        console.log('Lids selected:', lidsValue, 'requireLids:', this.requireLids);
        
        this.updatePricingTable();
      });
    });
  }

  setupTurnaroundSelector() {
    const turnaroundButtons = document.querySelectorAll('.turnaround-pill');
    turnaroundButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection
        turnaroundButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedTurnaround = btn.dataset.turnaround || 'standard';
        console.log('Turnaround selected:', this.selectedTurnaround);
        
        this.updatePricingTable();
        if (typeof this.updateShippingCalculator === 'function') {
          this.updateShippingCalculator();
        }
      });
    });
  }

  // Get pricing key for variant lookup
  getPricingKey() {
    return this.selectedSize;
  }

  // Update color availability based on selected quantity
  updateColorAvailability() {
    const rule = this.colourRules[this.selectedQuantity];
    if (!rule) return;
    
    const colorButtons = document.querySelectorAll('.color-btn');
    const availabilityText = document.querySelector('#color-availability-note');
    
    colorButtons.forEach(btn => {
      const colorCount = parseInt(btn.dataset.colors);
      
      if (colorCount >= rule.min && colorCount <= rule.max) {
        btn.classList.remove('disabled');
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      } else {
        btn.classList.add('disabled');
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        
        // Deselect if currently selected
        if (btn.classList.contains('selected')) {
          btn.classList.remove('selected');
          // Auto-select the maximum allowed
          const maxAllowedBtn = document.querySelector(`.color-btn[data-colors="${rule.max}"]`);
          if (maxAllowedBtn && !maxAllowedBtn.classList.contains('disabled')) {
            maxAllowedBtn.classList.add('selected');
            this.selectedColours = rule.max;
          }
        }
      }
    });
    
    if (availabilityText) {
      availabilityText.textContent = `Available colors: ${rule.min}-${rule.max} for selected quantity`;
    }
  }

  // Load product data for pricing
  async loadProductData() {
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('[Product Data] Loaded from existing script:', this.productData?.title);
        return;
      }
      
      // Fallback: get from window.meta or handle
      const productHandle = window.meta?.product?.handle || this.extractProductHandle();
      if (!productHandle) {
        console.warn('[Product Data] Could not determine product handle');
        return null;
      }
      
      console.log('[Product Data] Loading for handle:', productHandle);
      
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      this.productData = await response.json();
      console.log('[Product Data] Loaded via API:', this.productData?.title);
      
    } catch (error) {
      console.warn('[Product Data] Failed to load:', error);
      this.productData = null;
    }
  }
  
  extractProductHandle() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  // Robust fetch of a variant price in dollars (with cache)
  async fetchVariantPriceDollars(variantId) {
    if (!variantId) return null;
    if (this.variantPriceCache.has(variantId)) {
      return this.variantPriceCache.get(variantId);
    }
    const endpoints = [
      `/variants/${variantId}.json`,
      `/variants/${variantId}.js`
    ];
    for (const url of endpoints) {
      try {
        const res = await fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json,text/plain,*/*' } });
        if (!res.ok) continue;
        let data;
        try { data = await res.clone().json(); }
        catch (_) {
          const txt = await res.text();
          try { data = JSON.parse(txt); }
          catch (_) {
            const m = /"price"\s*:\s*"?([0-9]+(?:\.[0-9]+)?)"?/i.exec(txt);
            if (m) {
              const num = parseFloat(m[1]);
              if (isFinite(num)) { this.variantPriceCache.set(variantId, num); return num; }
            }
            continue;
          }
        }
        const v = data?.variant || data;
        if (!v) continue;
        let p = v.price;
        p = typeof p === 'string' ? parseFloat(p) : Number(p);
        if (!isFinite(p)) continue;
        if (p > 100 && Number.isInteger(p)) p = p / 100;
        this.variantPriceCache.set(variantId, p);
        return p;
      } catch (_) {}
    }
    return null;
  }

  async fetchVariantPricesBatch(ids) {
    const unique = [...new Set((ids || []).filter(Boolean))];
    const missing = unique.filter(id => !this.variantPriceCache.has(id));
    await Promise.all(missing.map(id => this.fetchVariantPriceDollars(id)));
  }

  async updatePricingTable() {
    const formEl = document.querySelector('#product-form-compostable-coffee-wholesale');
    const tbody = formEl ? formEl.querySelector('#quantity-grid-body') : document.getElementById('quantity-grid-body');
    if (!tbody) {
      console.log('No pricing table found');
      return;
    }

    // Guard against overlapping async renders
    const renderId = (this._pricingRenderCounter = (this._pricingRenderCounter || 0) + 1);

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    if (!variants) {
      if (renderId !== this._pricingRenderCounter) return;
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }

    await this.loadProductData();
    const frag = document.createDocumentFragment();

    const quantities = [10000, 16000, 32000, 50000, 64000];
    // Prefetch live prices for this mapping to reduce latency
    await this.fetchVariantPricesBatch(Object.values(variants));
    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];

      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;
      if (this.productData && variantId) {
        variant = this.productData.variants.find(v => v.id == variantId);
      }

      console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);

      if (variant) {
        const dollars = typeof variant.price === 'string' ? parseFloat(variant.price) : (variant.price / 100);
        variantPrice = dollars;
        unitPrice = variantPrice / qty;
      } else {
        // Try live price by variant ID first
        const live = this.variantPriceCache.get(variantId) ?? await this.fetchVariantPriceDollars(variantId);
        if (live != null) {
          variantPrice = live;
          unitPrice = live / qty;
          if (!this.variantPriceCache.has(variantId)) this.variantPriceCache.set(variantId, live);
        } else {
          console.warn(`Using fallback pricing for ${pricingKey} ${qty} units (variant ${variantId} not found or empty)`);
          if (qty >= 64000) unitPrice = 0.18;
          else if (qty >= 50000) unitPrice = 0.20;
          else if (qty >= 32000) unitPrice = 0.22;
          else if (qty >= 16000) unitPrice = 0.25;
          else unitPrice = 0.28;
          if (pricingKey.includes('22oz') || pricingKey.includes('24oz')) unitPrice *= 2.2;
          else if (pricingKey.includes('16oz')) unitPrice *= 1.6;
          else if (pricingKey.includes('12oz')) unitPrice *= 1.3;
          else if (pricingKey.includes('8oz')) unitPrice *= 1.1;
          else if (pricingKey.includes('6oz')) unitPrice *= 0.95;
          else if (pricingKey.includes('4oz')) unitPrice *= 0.85;
          variantPrice = unitPrice * qty;
        }
      }

      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;

      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateColorAvailability();
          this.updateOrderSummary();
          this.updateMediaGalleryForSelectedVariant();
        }
      });

      // Radio cell
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateColorAvailability();
          this.updateOrderSummary();
          this.updateMediaGalleryForSelectedVariant();
        }
      });

      // Preselect
      if ((i === 0 && this.selectedQuantity == null) || qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        row.classList.add('selected');
      }
      radioCell.appendChild(radio);
      row.appendChild(radioCell);

      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = qty.toLocaleString();
      row.appendChild(qtyCell);

      // Cartons
      const cartonsCell = document.createElement('td');
      const cartons = qty / this.UNITS_PER_CARTON;
      cartonsCell.textContent = this.decimalToFraction(cartons);
      row.appendChild(cartonsCell);

      // Unit Price (with membership)
      const unitPriceCell = document.createElement('td');
      let memberTier = null;
      let discountPercent = 0;
      const customerTags = document.querySelector('[data-customer-tags]')?.dataset.customerTags || '';
      if (customerTags) {
        const tags = customerTags.toLowerCase().split(',').map(t => t.trim());
        if (tags.includes('trade')) { memberTier = 'trade'; discountPercent = 20; }
        else if (tags.includes('gold')) { memberTier = 'gold'; discountPercent = 15; }
        else if (tags.includes('silver')) { memberTier = 'silver'; discountPercent = 10; }
        else if (tags.includes('bronze')) { memberTier = 'bronze'; discountPercent = 5; }
      }
      if (memberTier && discountPercent > 0) {
        const discountedUnit = unitPrice * (1 - discountPercent / 100);
        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(3)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnit.toFixed(3)}</span>
        `;
        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(3)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnit.toFixed(3)}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(3)}`;
      }
      row.appendChild(unitPriceCell);

      // Total (with membership)
      const totalCell = document.createElement('td');
      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        totalCell.innerHTML = `
          <span class="original-price">$${variantPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

      frag.appendChild(row);
    }

    // If a newer render started while building, abort to avoid double rows
    if (renderId !== this._pricingRenderCounter) return;

    tbody.innerHTML = '';
    tbody.appendChild(frag);

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
    this.updateMediaGalleryForSelectedVariant();
  }

  updateRowSelection() {
    document.querySelectorAll('.quantity-row').forEach(row => row.classList.remove('selected'));
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) selectedRow.classList.add('selected');
    }
  }

  updateSelectedQuantityDisplay() {
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    this.updateOrderSummary();
  }

  calculateUnitPrice() {
    return this.currentUnitPrice || 0;
  }

  calculatePlateFees() {
    const colours = Number(this.selectedColours) || 0;
    const plateFee = (this.selectedTurnaround && this.selectedTurnaround !== 'standard') ? this.URGENT_PLATE_FEE : this.STANDARD_PLATE_FEE;
    return colours * plateFee;
  }

  updateOrderSummary() {
    if (!this.selectedQuantity) return;

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];
    if (!variant && !this.currentUnitPrice) return;

    let unitPrice = this.calculateUnitPrice();
    let lidPrice = 0;
    let plateFee = this.calculatePlateFees();
    let rushFee = 0;
    let totalPrice = this.selectedQuantity * unitPrice;

    if (this.requireLids) {
      const lidUnit = this.LID_PRICE_HIGH_QTY;
      lidPrice = this.selectedQuantity * lidUnit;
      totalPrice += lidPrice;
      document.getElementById('summary-lid-row').style.display = '';
      document.getElementById('summary-lid-price').textContent = `$${lidPrice.toFixed(2)}`;
    } else {
      const lidRow = document.getElementById('summary-lid-row');
      if (lidRow) lidRow.style.display = 'none';
      const lidPriceEl = document.getElementById('summary-lid-price');
      if (lidPriceEl) lidPriceEl.textContent = '$0.00';
    }

    totalPrice += plateFee;
    const plateEl = document.getElementById('summary-plate-fee');
    if (plateEl) plateEl.textContent = `$${plateFee.toFixed(2)}`;

    const rushMultiplier = this.RUSH_MULTIPLIERS[this.selectedTurnaround] || 1.0;
    if (rushMultiplier > 1.0) {
      const baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
      rushFee = Math.round(baseCupTotal * (rushMultiplier - 1));
      totalPrice += rushFee;
      document.getElementById('summary-rush-row').style.display = '';
      document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
    } else {
      const rushRow = document.getElementById('summary-rush-row');
      if (rushRow) rushRow.style.display = 'none';
      const rushPriceEl = document.getElementById('summary-rush-fee');
      if (rushPriceEl) rushPriceEl.textContent = '$0.00';
    }

    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();

    // membership discounts
    let memberTier = null;
    let discountPercent = 0;
    const customerTags = document.querySelector('[data-customer-tags]')?.dataset.customerTags || '';
    if (customerTags) {
      const tags = customerTags.toLowerCase().split(',').map(t => t.trim());
      if (tags.includes('trade')) { memberTier = 'trade'; discountPercent = 20; }
      else if (tags.includes('gold')) { memberTier = 'gold'; discountPercent = 15; }
      else if (tags.includes('silver')) { memberTier = 'silver'; discountPercent = 10; }
      else if (tags.includes('bronze')) { memberTier = 'bronze'; discountPercent = 5; }
    }

    if (summaryUnitPrice) {
      if (memberTier && discountPercent > 0) {
        const discountedUnit = unitPrice * (1 - discountPercent / 100);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(3)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnit.toFixed(3)}</span>
          <span class="membership-badge membership-${memberTier}">${memberTier === 'trade' ? '💎' : memberTier === 'gold' ? '🥇' : memberTier === 'silver' ? '🥈' : '🥉'}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(3)}`;
      }
    }

    if (summaryTotal) {
      if (memberTier && discountPercent > 0) {
        const discountedTotal = totalPrice * (1 - discountPercent / 100);
        summaryTotal.innerHTML = `
          <span class="original-price">$${totalPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
      }
    }
  }

  // Utility functions
  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  formatNumber(number) {
    return new Intl.NumberFormat('en-US').format(number);
  }

  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return this.formatNumber(decimal);
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || this.formatNumber(decimal);
  }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const variantId = this.variantMapping[pricingKey]?.[quantityKey];
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      // Find the target media element
      const targetMedia = document.querySelector(`[data-media-id="${targetMediaId}"]`);
      if (!targetMedia) {
        console.log('Target media element not found:', targetMediaId);
        return;
      }
      
      // Simulate click on the target media to switch to it
      targetMedia.click();
      console.log('Switched to media:', targetMediaId);
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
          zIndex: 9999,
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          pointerEvents: 'none',
          opacity: '0',
          transition: 'opacity 0.15s ease',
          visibility: 'hidden'
        });

        // Ensure no bold text inside tooltip content
        tooltip.querySelectorAll('strong, b').forEach(el => {
          el.style.fontWeight = '400';
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        if (container) container.style.position = 'relative';
        (container || icon.parentElement || document.body).appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = (container || icon.parentElement || document.body).getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
            tooltip = null;
          }, 200);
        }
      };
      
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('focus', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('blur', hideTooltip);
      
      // Prevent tooltip from closing when clicking the icon
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
    // Clean up tooltips on page interactions
    document.addEventListener('scroll', () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => { if (t.parentNode) t.parentNode.removeChild(t); });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tooltip-icon')) {
        document.querySelectorAll('.tooltip-popup').forEach(t => { if (t.parentNode) t.parentNode.removeChild(t); });
      }
    });
  }

  setupFormSubmission() {
    const form = document.getElementById('product-form-compostable-coffee-wholesale');
    if (!form) return;
    
    form.addEventListener('submit', (e) => {
      // Get the current variant ID
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      const variantId = this.variantMapping[pricingKey]?.[quantityKey];
      
      if (!variantId) {
        e.preventDefault();
        this.showMessage('Please select a valid configuration', 'error');
        return;
      }
      
      // Update the variant input
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      }
      
      // Add plate fee to cart if colors > 0
      if (this.selectedColours > 0) {
        this.addPlateFeeToCart();
      }
      
      console.log('Form submitted with variant:', variantId, 'colors:', this.selectedColours);
    });

    // Also wire up the custom button to add via AJAX and open cart drawer (matches other products)
    const customButton = document.querySelector('#product-form-compostable-coffee-wholesale #custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCartAjax();
      });
    }
  }

  async addToCartAjax() {
    try {
      const button = document.getElementById('custom-add-to-cart-btn');
      if (button) {
        button.classList.add('loading');
        button.disabled = true;
      }

      // Resolve selected cup variant
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      const cupVariantId = this.variantMapping[pricingKey]?.[quantityKey];
      if (!cupVariantId) {
        this.showMessage('Please select a valid configuration', 'error');
        return;
      }

      // Build multipart payload (supports file upload)
      const formData = new FormData();
      const epkCartGroupId = `epkorder-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      let itemIndex = 0;

      // Cup line
      formData.append(`items[${itemIndex}][id]`, cupVariantId);
      formData.append(`items[${itemIndex}][quantity]`, '1');
      formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
      formData.append(`items[${itemIndex}][properties][Wall Type]`, this.selectedWall || 'Single');
      formData.append(`items[${itemIndex}][properties][Size]`, this.selectedSize);
      formData.append(`items[${itemIndex}][properties][Print Type]`, this.selectedPrintType);
      formData.append(`items[${itemIndex}][properties][Quantity]`, this.selectedQuantity);
      formData.append(`items[${itemIndex}][properties][Colours]`, this.selectedColours);
      itemIndex++;

      // Attach design file (if any)
      const fileInput = document.querySelector('#product-form-compostable-coffee-wholesale input[type="file"][name="properties[Design File]"]');
      if (fileInput && fileInput.files && fileInput.files[0]) {
        formData.append('files[]', fileInput.files[0]); // keep a copy for Shopify
        formData.append('properties[Design File]', fileInput.files[0]);
      }

      // Lids (optional) — supports tiered mapping (like recyclable) with safe fallback
      if (this.requireLids) {
        const color = (this.selectedLids || '').includes('white') ? 'white' : 'black';
        const lidTier = (q => {
          if (q >= 64000) return '64000';
          if (q >= 50000) return '50000';
          if (q >= 32000) return '32000';
          if (q >= 16000) return '16000';
          return '10000';
        })(this.selectedQuantity);
        let lidVariantId = null;
        const mapping = lidVariantMapping[color];
        if (mapping && typeof mapping === 'object') {
          lidVariantId = mapping[lidTier] || mapping['10000'] || null;
        } else {
          lidVariantId = mapping || null; // flat mapping fallback
        }
        if (lidVariantId) {
          formData.append(`items[${itemIndex}][id]`, lidVariantId);
          formData.append(`items[${itemIndex}][quantity]`, '1');
          formData.append(`items[${itemIndex}][properties][Type]`, 'Lids');
          formData.append(`items[${itemIndex}][properties][Color]`, color);
          formData.append(`items[${itemIndex}][properties][Quantity]`, this.selectedQuantity);
          formData.append(`items[${itemIndex}][properties][For Cup Size]`, this.selectedSize);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
          itemIndex++;
        }
      }

      // Printing plates (quantity = number of colours)
      if (this.selectedColours > 0) {
        const isUrgent = this.selectedTurnaround && this.selectedTurnaround !== 'standard';
        const plateVariant = isUrgent ? urgentPlateFeeVariantId : plateFeeVariantId;
        if (plateVariant) {
          formData.append(`items[${itemIndex}][id]`, plateVariant);
          formData.append(`items[${itemIndex}][quantity]`, String(this.selectedColours));
          formData.append(`items[${itemIndex}][properties][Type]`, 'Printing Plates');
          formData.append(`items[${itemIndex}][properties][Colours]`, this.selectedColours);
          formData.append(`items[${itemIndex}][properties][For Order]`, `${this.selectedSize} ${this.selectedQuantity} cups`);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
          itemIndex++;
        }
      }

      // Add rush fee as a separate $1 product if a rushed turnaround is selected (skip for members)
      const rushMultiplier = this.RUSH_MULTIPLIERS?.[this.selectedTurnaround] || 1.0;
      if (rushMultiplier > 1.0) {
        const customerTags = (window.customer && Array.isArray(window.customer.tags)) ? window.customer.tags : [];
        const isMember = customerTags.some(tag => {
          try { return String(tag).toLowerCase().match(/bronze|silver|gold/); } catch(_) { return false; }
        });
        {
          // Rush charged for everyone (members included); Shopify discount applies it once.
          const baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
          const rushFeeAmount = baseCupTotal * (rushMultiplier - 1);
          const rushFeeQuantity = Math.round(rushFeeAmount);
          if (rushFeeQuantity > 0) {
            formData.append(`items[${itemIndex}][id]`, '50675778126106');
            formData.append(`items[${itemIndex}][quantity]`, String(rushFeeQuantity));
            formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${baseCupTotal.toFixed(2)}`);
            formData.append(`items[${itemIndex}][properties][Rush Fee (${this.selectedTurnaround})]`, `$${rushFeeAmount.toFixed(2)}`);
            formData.append(`items[${itemIndex}][properties][Turnaround]`, this.selectedTurnaround);
            formData.append(`items[${itemIndex}][properties][_epk_group]`, epkCartGroupId);
            itemIndex++;
          }
        }
      }

      // Post to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: formData
      });

      if (!response.ok) {
        let errMsg = `Failed to add to cart: ${response.status}`;
        try { const errJson = await response.json(); if (errJson?.description) errMsg += ` - ${errJson.description}`; } catch (_) {}
        throw new Error(errMsg);
      }

      // Force a hard refresh so only the selected lines show and theme state is clean
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.location.reload();
    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      const button = document.getElementById('custom-add-to-cart-btn');
      if (button) {
        button.classList.remove('loading');
        button.disabled = false;
      }
    }
  }

  async refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' });
      const sections = await res.json();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && sections['cart-drawer']) {
        const temp = document.createElement('div');
        temp.innerHTML = sections['cart-drawer'];
        const newInner = temp.querySelector('.drawer__inner');
        const curInner = cartDrawer.querySelector('.drawer__inner');
        if (newInner && curInner) curInner.replaceWith(newInner);
      }
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon && sections['cart-icon-bubble']) {
        cartIcon.innerHTML = sections['cart-icon-bubble'];
      }
    } catch (e) {
      console.warn('Failed to refresh cart drawer sections', e);
    }
  }

  openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // Fallback events
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    const toggle = document.querySelector('[data-cart-drawer-open], .cart-drawer-toggle, .header__icon--cart');
    if (toggle) try { toggle.click(); } catch (_) {}
  }

  async addPlateFeeToCart() {
    try {
      const plateFeeData = {
        items: [{
          id: this.printingPlateFeeProductId,
          quantity: this.selectedColours,
          properties: {
            '_plate_fee': 'true',
            '_colors': this.selectedColours,
            '_for_product': this.selectedSize
          }
        }]
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(plateFeeData)
      });
      
      if (response.ok) {
        console.log('Plate fee added to cart:', this.selectedColours, 'colors');
      } else {
        console.warn('Failed to add plate fee to cart');
      }
    } catch (error) {
      console.error('Error adding plate fee to cart:', error);
    }
  }

  setupFileUpload() {
    const fileInput = document.querySelector('#product-form-compostable-coffee-wholesale input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('#product-form-compostable-coffee-wholesale div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('#product-form-compostable-coffee-wholesale img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('#product-form-compostable-coffee-wholesale div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('#product-form-compostable-coffee-wholesale div[id^="fileInfo-"]');
    const fileName = document.querySelector('#product-form-compostable-coffee-wholesale div[id^="fileName-"]');
    const fileSize = document.querySelector('#product-form-compostable-coffee-wholesale div[id^="fileSize-"]');
    const removeButton = document.querySelector('#product-form-compostable-coffee-wholesale button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }

  setupShippingCalculator() {
    // Initialize delivery time calculator (match recyclable wholesale behavior)
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    // Determine production days and shipping times based on turnaround selection
    let productionDays, minDeliveryDays, maxDeliveryDays;
    
    switch (this.selectedTurnaround) {
      case '5days':
        productionDays = 5;
        minDeliveryDays = 6;
        maxDeliveryDays = 8;
        break;
      case '10days':
        productionDays = 10;
        minDeliveryDays = 11;
        maxDeliveryDays = 13;
        break;
      case '15days':
        productionDays = 15;
        minDeliveryDays = 16;
        maxDeliveryDays = 18;
        break;
      case 'standard':
      default:
        productionDays = 30; // 30 business days
        minDeliveryDays = 31;
        maxDeliveryDays = 33;
        break;
    }

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Update delivery range with selected production time
    let productionTimeText;
    switch (this.selectedTurnaround) {
      case '5days':
        productionTimeText = 'Urgent (5 business days) +25%';
        break;
      case '10days':
        productionTimeText = 'Rushed (10 business days) +15%';
        break;
      case '15days':
        productionTimeText = 'Express (15 business days) +8%';
        break;
      case 'standard':
      default:
        productionTimeText = 'Standard (30 business days)';
        break;
    }
    
    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize description content and accordion behavior
    this.updateDynamicDescription();
    this.setupAccordionBehavior('.dynamic-description');
    this.setupAccordionBehavior('.dynamic-description-mobile');
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopContent = document.getElementById('description-content');
    if (desktopTitle && desktopContent) {
      desktopTitle.classList.add('active');
      desktopContent.classList.add('active');
    }

    // Open description tab on mobile
    const mobileTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileContent = document.getElementById('description-content-mobile');
    if (mobileTitle && mobileContent) {
      mobileTitle.classList.add('active');
      mobileContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const titles = container.querySelectorAll('.dropdown-title');
    titles.forEach((title) => {
      // Ensure bold styling
      title.style.setProperty('font-weight', '700', 'important');

      title.addEventListener('click', () => {
        const targetId = title.getAttribute('data-target');
        const targetEl = document.getElementById(targetId);
        if (!targetEl) return;

        const isActive = title.classList.contains('active');
        // Close all
        titles.forEach((other) => {
          const otherId = other.getAttribute('data-target');
          const otherEl = document.getElementById(otherId);
          other.classList.remove('active');
          if (otherEl) otherEl.classList.remove('active');
        });
        // Toggle current
        if (!isActive) {
          title.classList.add('active');
          targetEl.classList.add('active');
        }
      });
    });
  }

  updateDynamicDescription() {
    const data = this.getDescriptionData();

    // Desktop containers
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');

    if (descriptionContent) descriptionContent.innerHTML = data.description;
    if (specificationContent) specificationContent.innerHTML = data.specification;
    if (dielinesContent) dielinesContent.innerHTML = data.dielines;
    if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) howItWorksContent.innerHTML = data.howItWorks;

    // Mobile containers
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');

    if (descriptionContentMobile) descriptionContentMobile.innerHTML = data.description;
    if (specificationContentMobile) specificationContentMobile.innerHTML = data.specification;
    if (dielinesContentMobile) dielinesContentMobile.innerHTML = data.dielines;
    if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) howItWorksContentMobile.innerHTML = data.howItWorks;
  }

  getDescriptionData() {
    // Single Wall content (wholesale flexo)
    const sizeDescriptions = {
      "4oz": {
        description: `
          <p>Our 4oz (110ml) Compostable Wholesale Cups are designed for high-volume commercial use. Ideal for sampling and espresso service with premium flexographic printing.</p>
          <p>Available with <strong>Flexographic printing only</strong> — fast, cost-effective production for wholesale quantities.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">110ml (4oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
            <li><span class="spec-label">Colors Available:</span> <span class="spec-value">1-5 colors (depending on quantity)</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your flexographic printing artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/4oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 4oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "6oz": {
        description: `
          <p>Our 6oz (220ml) Compostable Wholesale Cups are perfect for cappuccinos and specialty drinks at scale.</p>
          <p>Available with <strong>Flexographic printing only</strong> — consistent results across your entire order.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">220ml (6oz)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the wholesale dieline template for your artwork:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/6oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 6oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "8oz": {
        description: `
          <p>Our 8oz (250ml) Compostable Wholesale Cups are the standard for coffee service at volume.</p>
          <p><strong>Double Wall (optional)</strong> for better insulation on hot drinks — available only for 8oz, 12oz and 16oz. Wholesale printing is <strong>Flexographic</strong> for high-speed, durable results.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Single or Double Wall (DW: better insulation)</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
          </ul>
        `,
        dielines: `
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 8oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "12oz": {
        description: `
          <p>Our 12oz (395ml) Compostable Wholesale Cups balance capacity and comfort.</p>
          <p><strong>Double Wall (optional)</strong> adds hand-friendly insulation — available for 12oz. Printing is <strong>Flexographic</strong> to suit wholesale production.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Single or Double Wall (DW: better insulation)</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
          </ul>
        `,
        dielines: `
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 12oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "16oz": {
        description: `
          <p>Our 16oz (480ml) Compostable Wholesale Cups support premium, large drinks at scale.</p>
          <p><strong>Double Wall (optional)</strong> delivers superior heat retention — available for 16oz. Printing is <strong>Flexographic</strong> for high-volume consistency.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Single or Double Wall (DW: better insulation)</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
          </ul>
        `,
        dielines: `
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 16oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "22oz": {
        description: `
          <p>Our 22oz (610ml) Compostable Wholesale Cups are built for extra-large beverages and high visibility.</p>
          <p>Consistent, high-speed flexographic printing.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">610ml (22oz)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
          </ul>
        `,
        dielines: `
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/22oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 22oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "24oz": {
        description: `
          <p>Our 24oz (730ml) Compostable Wholesale Cups provide maximum capacity and branding space.</p>
          <p>Flexographic printing for efficient, durable results.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">730ml (24oz)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
          </ul>
        `,
        dielines: `
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/24oz_Cup_Wholesale_Template.pdf" class="download-btn" target="_blank">👉 Download 24oz Wholesale Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      }
    };

    // Double Wall content (only 8/12/16)
    const sizeDescriptionsDouble = {
      "8oz": {
        description: `
          <p>Our 8oz (250ml) <strong>Double Wall</strong> Compostable Wholesale Cups provide better heat insulation for hot beverages at volume. Double Wall removes the need for sleeves.</p>
          <p>Wholesale printing is <strong>Flexographic</strong> for durable, high-speed production.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">250ml (8oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Double Wall</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">10,000 units</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the Double Wall template for precise print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8ozA_Double_Wall_Cup_Template_ea30899c-7167-40f1-964e-4b68d177f846.pdf?v=1762386998" class="download-btn" download="8ozA_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 8oz Double Wall Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "12oz": {
        description: `
          <p>Our 12oz (395ml) <strong>Double Wall</strong> Compostable Wholesale Cups offer comfortable handling without sleeves for medium serves.</p>
          <p>Wholesale printing is <strong>Flexographic</strong> to suit high-volume production.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">395ml (12oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Double Wall</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the Double Wall template for precise print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/12ozXL_Double_Wall_Cup_Template_5489dcae-8e3f-4cd8-819f-5cdc549b2ae2.pdf?v=1762386998" class="download-btn" download="12ozXL_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 12oz Double Wall Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      },
      "16oz": {
        description: `
          <p>Our 16oz (480ml) <strong>Double Wall</strong> Compostable Wholesale Cups deliver superior insulation for large hot drinks.</p>
          <p>Wholesale printing is <strong>Flexographic</strong> for consistent coverage across big runs.</p>
          <p><strong>Minimum order: 10,000 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">480ml (16oz)</span></li>
            <li><span class="spec-label">Construction:</span> <span class="spec-value">Double Wall</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Flexographic (wholesale)</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">AS 5810 Home Compostable</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the Double Wall template for precise print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/16oz_Double_Wall_Cup_Template_045d62b5-215e-4b46-9715-0ffd0685cc4b.pdf?v=1762386998" class="download-btn" download="16oz_Double_Wall_Cup_Template.pdf" target="_blank">👉 Download 16oz Double Wall Template</a>
        `,
        howItWorks: this.getHowItWorksMarkup()
      }
    };

    const map = this.selectedWall === 'Double' ? sizeDescriptionsDouble : sizeDescriptions;
    return map[this.selectedSize] || (this.selectedWall === 'Double' ? sizeDescriptionsDouble['8oz'] : sizeDescriptions['8oz']);
  }

  getHowItWorksMarkup() {
    return (window.getWholesaleHowItWorksMarkup
      ? window.getWholesaleHowItWorksMarkup()
      : `
      <div class="process-timeline">
        <div class="process-step">
          <div class="process-number">1</div>
          <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
        </div>
        <div class="process-step">
          <div class="process-number">2</div>
          <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
        </div>
        <div class="process-step">
          <div class="process-number">3</div>
          <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom cups go into production — standard turnaround is 30 business days.</div>
        </div>
        <div class="process-step">
          <div class="process-number">4</div>
          <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
        </div>
      </div>
    `);
  }

  checkCartAddSuccess() {
    // Check if there's a success message in URL params
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cart_add') === 'success') {
      this.showMessage('Added to cart successfully!', 'success');
      
      // Clean up URL
      const newUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }

  preventAutoScroll() {
    // Prevent automatic scrolling when updating variant
    const originalScrollTo = window.scrollTo;
    window.scrollTo = function(x, y) {
      if (arguments.length === 0) return;
      originalScrollTo.call(window, x, y);
    };
  }

  showMessage(text, type = 'info') {
    // Create and show a temporary message
    const message = document.createElement('div');
    message.className = `product-message product-message--${type}`;
    message.textContent = text;
    
    // Style the message
    Object.assign(message.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '1rem 1.5rem',
      backgroundColor: type === 'error' ? '#ef4444' : type === 'success' ? '#10b981' : '#3b82f6',
      color: 'white',
      borderRadius: '0.5rem',
      zIndex: '9999',
      opacity: '0',
      transition: 'opacity 0.3s ease'
    });
    
    document.body.appendChild(message);
    
    // Animate in
    setTimeout(() => {
      message.style.opacity = '1';
      message.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      message.classList.add('hide');
      setTimeout(() => {
        message.remove();
      }, 300);
    }, 3000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('✅ Initializing Compostable Coffee Cup Wholesale Product...');
  window.coffeeCupWholesaleProduct = new CompostableCoffeeCupWholesaleProduct();
}); 